import React from "react";
import PropTypes from "prop-types";

import ProfileComment from "shared/components/ProfileComment";
import Str from "shared/components/Str";
import Strf from "shared/components/Strf";
import _str from "shared/util/_str";
import PhoneWallExplainer from "apps/messenger/components/PhoneWallExplainer";

import { getUserInstruction } from "apps/messenger/util/helpers";

import "apps/messenger/components/MainWindow/EmptyState.scss";

const getDefault = () => {
	return {
		title: _str("Nothing to see here 👻"),
		body: (
			<Strf vars={{
				feedbackCTA: (
					<a className="banner-link" rel="noopener noreferrer" href="https://help.okcupid.com">
						<Str>let us know!</Str>
					</a>
				),
			}}>If you think this is an error, $feedbackCTA</Strf>
		),
	};
};

const EmptyState = (props) => {
	let state;

	if (props.showOcsBlock || props.showInstructions) {
		state = getUserInstruction(props);
	} else {
		state = getDefault();
	}

	if (props.showPhoneWall) {
		return <PhoneWallExplainer name={props.username} />;
	}

	return (
		<div className="messenger-empty-state">
			{state.image && (
				<img
					className="messenger-empty-state-image"
					alt={state.imageAlt}
					src={state.image}
				/>
			)}
			{state.title && (typeof state.title === "string" ? (
				<h3
					className="messenger-empty-state-title"
					dangerouslySetInnerHTML={{ __html: state.title }}
				/>
			) : state.title)}
			{state.body && (typeof state.body === "string" ? (
				<p
					className="messenger-empty-state-text"
					dangerouslySetInnerHTML={{ __html: state.body }}
				/>
			) : state.body)}
			{state.link && state.linkText && (
				<a href={state.link} className="messenger-empty-state-button">{state.linkText}</a>
			)}
			{props.showInstructions && props.profileComment && (
				<ProfileComment className="comment-preview" {...props.profileComment} />
			)}
		</div>
	);
};

EmptyState.propTypes = {
	showOcsBlock: PropTypes.bool.isRequired,
	showInstructions: PropTypes.bool.isRequired,
	username: PropTypes.string.isRequired,
	showPhoneWall: PropTypes.bool.isRequired,

	// These are used in the getUserInstructionBlock func.
	/* eslint-disable react/no-unused-prop-types */
	userInstructions: PropTypes.object,
	profileComment: PropTypes.object,
	likedThisSession: PropTypes.bool,
	/* eslint-enable react/no-unused-prop-types */
};

EmptyState.defaultProps = {
	userInstructions: null,
	profileComment: null,
	likedThisSession: false,
};

export default EmptyState;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/MainWindow/EmptyState.jsx